import React from 'react';
import {
  Form, Row, Col, Input, Button,
} from 'antd';

import MiCompAPI from '../../../util/api';
import ReCAPTCHA from "react-google-recaptcha";
import InputMask from "react-input-mask";
class ClientRegistrationForm extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err && !this.state.isValueExists) {
        this.props.submitHandler(values)
      }
    });
  }
  constructor(props) {
    super(props);
    this.state = { isValueExists: false };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }

  handleChange = (e) => {
    if (e.target.value && e.target.value.length > 7) {
      this.api.invoke("IsValueExists/USERS/" + e.target.value + "/EMAIL", "get", (data, success) => {
        if (success) {
          this.setState({ isValueExists: data.data });
        }
      });
    }
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="mi_model_popup1">
        <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
          <Row span={24}>
            <Col sm={24}>
              <Form.Item>
                <fieldset className="mi_fieldset1 mi_input_pop">
                  <legend className="legend-font">Company Name</legend>
                  {getFieldDecorator('client_name', {
                    rules: [{ required: true, message: 'Please enter Company Name.' },
                     {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s]+$/,
                      message: "It allows only Alphanumerics,No whitespace at the beginning and end"
                    }],
                  })(<Input type="text" maxLength={40} autoComplete={"nope"}  className="mi_input" placeholder="Enter Company Name *" />)}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>
          <Row span={24}>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_fieldset1 mi_input_pop">
                  <legend className="legend-font">Contact First Name</legend>
                  {getFieldDecorator('primary_Contact_First_Name', {
                    rules: [{ required: true, message: 'Please enter contact first name.' }, {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "It allows only Alphabets,No whitespace at the beginning and end"
                    }],
                  })(<Input type="text" maxLength={40} autoComplete={"nope"}  className="mi_input" placeholder="Enter Contact First Name * " />)}
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_fieldset1 mi_input_pop">
                  <legend className="legend-font">Contact Last Name</legend>
                  {getFieldDecorator('primary_Contact_Last_Name', {
                    rules: [{ required: true, message: 'Please enter contact Last Name.' }, {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "It allows only Alphabets,No whitespace at the beginning and end"
                    }],
                  })(<Input type="text" autoComplete={"nope"}  maxLength={40} className="mi_input" style={{marginLeft:'-8px'}}  placeholder="Enter Contact Last Name *" />)}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>
          <Row span={24}>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_fieldset1 mi_input_pop">
                  <legend className="legend-font">Contact Email Id</legend>
                  {getFieldDecorator('primary_Contact_Email', {
                    rules: [{
                      type: 'email', message: 'Please enter valid Email.',
                    }, { required: true, message: 'Please enter carrier  email id.' },{ whitespace: true, message: "Email is invalid." },
                    {
                      pattern: /^([a-zA-Z0-9\s.]+)@([a-zA-Z0-9]+)\.([a-zA-Z]{2,5})$/,
                      message: 'Email is invalid.'}],
                  })(<Input type="email" onChange={this.handleChange.bind(this)} autoComplete={"nope"}  className="mi_input"  placeholder="Enter Contact Email Id *" />)}
                </fieldset>
              </Form.Item>
              {this.state.isValueExists ? <p style={{ color: "red", marginTop: '-12px', marginLeft: '10px' }}>Email already exists</p> : ""}
            </Col>
            <Col md={12} sm={24}  >
              <Form.Item>
                <fieldset className="mi_fieldset1 mi_input_pop">
                  <legend className="legend-font">Tax Id</legend>
                  {getFieldDecorator('client_tax_id', {
                    rules: [{
                      required: true, message: "Please enter Tax Id",
                    }, {pattern:/^([07][1-7]|1[0-6]|2[0-7]|[35][0-9]|[468][0-8]|9[0-589])-?\d{7}$/ ,
                    message:'Tax Id is invalid'}],
                  })(
                    <InputMask mask="99-9999999" autoComplete={"nope"}  className="ant-input mi_input" type="text"   placeholder="Enter Tax Id *" />
                  )}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>
          <Row span={24}>
            <Form.Item style={{ float: 'right',marginRight:'16px' }}>
              {getFieldDecorator('captcha', {
                rules: [{ required: true, message: 'Captcha is Required.' }],
              })(<ReCAPTCHA sitekey={this.props.TEST_SITE_KEY}></ReCAPTCHA>)}
            </Form.Item>
          </Row>
          <Row span={24}  className="ant-row1" >

              <Button className="submit-button" htmlType="submit" type="primary">
                Register
              </Button>

              <Button className="submit-button" onClick={this.props.Cancel} >
                Cancel
              </Button>



          </Row>
        </Form>
      </div>
    );
  }
}
export default ClientRegistrationForm